export default "__VITE_ASSET__BUOEqe_q__"